import { WarningOutlined } from "@ant-design/icons";
import { Modal, Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from 'react-query';
import { deletePriceList } from "../../api/priceLists";
import { message } from "antd";
import { PriceListsInterface } from "./Interfaces";

type prop = {
    itemToDelete: {
        name: string,
        id: number
    };
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    title?: any;
    setSaleLists: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
    setSaleListsSearch: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
}
const DeletePrice = ({ open, setOpen, title, setSaleLists, itemToDelete, setSaleListsSearch }: prop) => {
    const [t] = useTranslation("common");

    const { mutateAsync: deletePriceListMutation, isLoading } = useMutation(
        "deletePriceList",
        ({ id }: { id: number }) =>
            deletePriceList({ id }),
        {
            onSuccess: ({ data }) => {
                message.success(data.message)
                setSaleLists(data.data)
                setSaleListsSearch(data.data)
                setOpen(false);
            },
            onError: ({ response }) => {
                message.error(response.data.message)
            }
        }
    );

    const handleclick = () => {
        deletePriceListMutation({ id: itemToDelete.id });
    };

    return (
        <>
            <Modal
                closable={false}
                maskClosable={false}
                onCancel={() => setOpen(false)}
                open={open}
                centered
                title={
                    <>
                        <Row>
                            <Col span={3}>
                                <WarningOutlined
                                    style={{
                                        marginTop: "22px",
                                        color: "red",
                                        fontSize: "45px",
                                        marginRight: "12px",
                                    }}
                                />
                            </Col>
                            <Col span={19}>
                                <Col
                                    style={{
                                        fontSize: "32px",
                                        color: "#212121",
                                    }}
                                >
                                    {" "}
                                    {t("confirm-delete")}
                                </Col>
                                <Col
                                    span={19}
                                    style={{
                                        fontSize: "16px",
                                        color: "#212121",
                                        wordWrap: "break-word",
                                    }}
                                >
                                    {t("please-confirm-deleting")} {title}
                                </Col>
                                <Col
                                    span={24}
                                    style={{
                                        fontSize: "15px",
                                        color: "#212121",
                                    }}
                                >
                                    {itemToDelete.name}
                                </Col>
                            </Col>
                        </Row>
                    </>
                }
                onOk={handleclick}
                okText={`${t("confirm")}`}
                cancelText={`${t("cancel")}`}
                okButtonProps={{
                    style: {
                        height: "40px",
                        background: "#1677FF",
                        color: "#fff",
                        width: "100px",
                    },
                    loading: isLoading
                }}
                cancelButtonProps={{
                    style: {
                        color: "#1677FF",
                        border: "1px solid #1677FF",
                        height: "40px",
                        width: "100px",
                    },
                }}
            />
        </>
    );
};
export default DeletePrice;
